"use strict";

import {onFind} from "./elements-packages/init-modules-in-scope";
import {on, removeAttribute} from '@elements/dom-utils';
import {registerPermissionGrantedCallback} from "./elements-packages/cookie-permissions";

export function init () {
    onFind(".js-open-snap-engage-link", function (chatLink) {
        let cookieService = chatLink.dataset.loadChatWithConsent || false;

        if(cookieService) {
            registerPermissionGrantedCallback(cookieService, function () {
                removeAttribute('hidden', chatLink);
                on('click', function (evt) {
                    (function () {
                        var se = document.createElement('script');
                        se.type = 'text/javascript';
                        se.async = true;
                        se.src = '//storage.googleapis.com/code.snapengage.com/js/48077c86-594f-47a0-95b2-7eab7f7c9c3e.js';
                        var done = false;
                        se.onload = se.onreadystatechange = function () {
                            if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                                done = true;
                                SnapABug.setLocale('<?= $this->language; ?>');

                                SnapEngage.startLink();

                                SnapABug.getAgentStatusAsync(function (online) {
                                    if (online) {
                                        //document.body.className += " chat-online";
                                    } else {
                                        //document.body.className += " chat-offline";
                                    }
                                });
                            }
                        };
                        var s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(se, s);
                    })();
                }, chatLink);
            });
        } else {
            console.warn('load-chat-with-consent: no cookie service name found!')
        }
    });
}